import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { KudosTask } from "../../../taskbook-triage/taskbook.types";
import { tap } from "rxjs";
import { TaskbookService } from "../../../taskbook-triage/taskbook.service";
import { TmTaskbookModule } from "../../../taskbook-triage/taskbook-triage.module";
import { RouterLink } from "@angular/router";
import { TmPipesModule } from "../../../shared/util/pipes";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Reactions, ReactionsComponent, Thread, TimelineItemType } from "../../../timeline/timeline-item";
import { ThreadsComponent } from "../../../timeline/threads/threads.component";
import { TaskThreadsComponent } from "../../../taskbook-triage/task/task-threads/task-threads.component";
import { UserInfos } from "../../../shared/ui/username-icon/user-infos.type";

@Component({
    selector: 'kudos-task-details-dialog',
    templateUrl: './kudos-task-details-dialog.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    TmTaskbookModule,
    TmPipesModule,
    RouterLink,
    MatTooltipModule,
    ReactionsComponent,
    TaskThreadsComponent
]
  })
  export class KudosTaskDetailsDialogComponent implements OnInit {
  
    kudos: KudosTask;
    loading = true;
    threadInCreation = false;
    userInfos: UserInfos;
  
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: KudosTaskDetailsDialogData,
      private dialogRef: MatDialogRef<KudosTaskDetailsDialogComponent>,
      private taskbookService: TaskbookService
    ) { }
  
    ngOnInit(): void {
        const kudosId = this.data.kudosId;
        this.taskbookService.taskDetails('kudosItem', kudosId).pipe(
            tap(taskData => {
                this.kudos = (taskData.task as KudosTask);
                this.loading = false;            
            })
        ).subscribe();
    }

    async onThreadCreation(newThread: Thread){
      if(newThread){
          // this.onAction.emit({threadContent: newThread})
      }
  }

    async onCancelCreation(){
        // this.onAction.emit()
    }

    protected onReacted(task: {id: string, itemType: TimelineItemType} & Reactions): void {
        // this.task.reactions = task.reactions;
    }

    protected onReported(): void {
        // this.onReportTaskContent.emit()
    }
  
    close(){
      this.dialogRef.close();
    }
  }


  export interface KudosTaskDetailsDialogData {
    kudosId: string
  }